<div class="btnList">
  <button class="button-primary"
    [ngClass]="selectedHeaderIds.size == 0 || !isUserHaveAccess ? 'btn-disabled' : 'button-secondary'"
    (click)="clearSelectedHeader()">
    Clear Selected
  </button>
</div>
<div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td" (mouseover)="showTooltip($event)"
  position="right">
  <div id="nonStyleGrid" class="mt20">
    <kendo-grid [rowClass]="mainGridRowCallback" [data]="eplMasterViewData" class="buildGrid" 
      [selectable]="{ enabled: true, checkboxOnly: true }" (selectionChange)="onSelectionChangeEvent($event, true)">
      <kendo-grid-checkbox-column [width]="45" [headerClass]="{ 'text-center': true }" [class]="{ 'text-center': true }"
        [resizable]="false" [columnMenu]="true" [columnMenu]="false"
        [showSelectAll]="true"></kendo-grid-checkbox-column>
      <kendo-grid-column title="" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="dataItem.acdAction == 'Add'">
            <span (click)="openTagNumberPopup(dataItem, rowIndex)" *ngIf="!dataItem.isLocal"
              [class.icon-disabled2]="!isUserHaveAccess">
              <fa-icon [icon]="iconPacks.FASQUAREPLUS" class="primaryBlue btnSize"
                [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
              </fa-icon>
            </span>

            <span (click)="deleteMasterChildEntry(dataItem.changeItemId)" class="ml-5"
              [class.icon-disabled2]="!isUserHaveAccess">
              <fa-icon [icon]="iconPacks.FACIRCLE" class="primaryBlue btnSize"
                [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
              </fa-icon>
            </span>
          </div>

          <div *ngIf="dataItem.acdAction == 'No change'">
            <span (click)="deleteMasterChildEntry(dataItem.changeItemId)" class=""
              [class.icon-disabled2]="!isUserHaveAccess">
              <fa-icon [icon]="iconPacks.FAMINUSSQUARE" class="primaryBlue btnSize"
                [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
              </fa-icon>
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="acdAction" title="ACD Action" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="tagNumber_View" title="Tag Number" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="headerTagNumberSpan" id="{{'headerTagNumber_' + rowIndex}}"
            [innerHTML]="dataItem.tagNumber_View">
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="eplShort" title="EPL Short" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="eplLong" title="EPL Long" [width]="250">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-textbox *ngIf="dataItem.acdAction == 'Add'" [(ngModel)]="dataItem.eplLong"
            [disabled]="!isUserHaveAccess" (valueChange)="onHeaderValueChange(dataItem, 'eplLong', $event)"
            [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('eplLong')}"
            id="{{ dataItem.changeItemId + '_eplLong' }}"></kendo-textbox>
          <span *ngIf="dataItem.acdAction == 'No change'">{{dataItem.eplLong}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="modelNumber" title="Model Number" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="">
            <kendo-textbox *ngIf="dataItem.acdAction == 'Add'" [(ngModel)]="dataItem.modelNumber"
              [disabled]="!isUserHaveAccess" (valueChange)="onHeaderValueChange(dataItem, 'modelNumber', $event)"
              [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('modelNumber')}"
              [placeholder]="'Model Number'" id="{{ dataItem.changeItemId + '_modelNumber' }}"></kendo-textbox>
            <span *ngIf="dataItem.acdAction == 'No change'">{{dataItem.modelNumber}}</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="manufacturer" title="Manufacturer" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="">
            <kendo-textbox *ngIf="dataItem.acdAction == 'Add'" [(ngModel)]="dataItem.manufacturer"
              [disabled]="!isUserHaveAccess" (valueChange)="onHeaderValueChange(dataItem, 'manufacturer', $event)"
              [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('manufacturer')}"
              [placeholder]="'Manufacturer'" id="{{ dataItem.changeItemId + '_manufacturer' }}"></kendo-textbox>
            <span *ngIf="dataItem.acdAction == 'No change'">{{dataItem.manufacturer}}</span>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <div>
    <span class="eplLength">{{ eplMasterViewData.length }} EPL Headers</span>
  </div>
  <div class="margin-15">
    <kendo-expansionpanel title="Items" class="expansion" [expanded]="true" (click)="expandCollapseContent()">
      <div class="margin-15 btnExpList">
        <button class="button-secondary" (click)="openAddOrDeletePopup()" [disabled]="!isUserHaveAccess"
          [ngClass]="!isUserHaveAccess?'btn-disabled':''">Add/Delete Items</button>
        <button class="button-secondary" (click)="clickExport($event)">
          Export
        </button>
        <button class="button-secondary" (click)="clickImport($event)" [disabled]="!isUserHaveAccess"
          [ngClass]="!isUserHaveAccess?'btn-disabled':''">
          Import
        </button>
      </div>
      <div id="nonStyleGrid" class="margin-15">
        <kendo-grid [rowClass]="rowCallback" [data]="eplChildViewData" class="buildGrid"
          [selectable]="{ enabled: true, checkboxOnly: true }" (selectionChange)="onSelectionChangeEvent($event)">
          <kendo-grid-checkbox-column [width]="45" [headerClass]="{ 'text-center': true }"
            [class]="{ 'text-center': true }" [resizable]="false" [columnMenu]="true" [columnMenu]="false"
            [showSelectAll]="true"></kendo-grid-checkbox-column>
          <kendo-grid-column title="" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div>
                @if(!dataItem.hideDelete) {
                <span (click)="deleteItem(dataItem)" [class.icon-disabled2]="!isUserHaveAccess"
                  *ngIf="dataItem.acdAction == 'No change' || dataItem.acdAction == 'Change'">
                  <fa-icon [icon]="iconPacks.FAMINUSSQUARE" class="primaryBlue btnSize"
                    [ngClass]="isUserHaveAccess?'':'icon-disabled2'">
                  </fa-icon>
                </span>
                }

                <span (click)="undoItem(dataItem, rowIndex)" [class.icon-disabled2]="!isUserHaveAccess"
                  *ngIf="dataItem.acdAction == 'Change' || dataItem.acdAction == 'Delete'">
                  <fa-icon [icon]="iconPacks.FACIRCLE" class="primaryBlue btnSize"
                    [ngClass]="isUserHaveAccess?'':'icon-disabled2'"
                    [ngClass]="{'ml-5': dataItem.acdAction == 'Change'}">
                  </fa-icon>
                </span>

                <span (click)="removeItem_Action_Add(rowIndex)" *ngIf="dataItem.acdAction == 'Add'"
                  [class.icon-disabled2]="!isUserHaveAccess">
                  <fa-icon [icon]="iconPacks.FACIRCLE" class="primaryBlue btnSize"
                    [ngClass]="isUserHaveAccess?'':'icon-disabled2'"
                    [ngClass]="{'ml-5': dataItem.acdAction == 'Change'}">
                  </fa-icon>
                </span>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="tagNumber_View" title="Tag Number" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <span class="itemTagNumberSpan" [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}"
                id="{{'itemTagNumber_' + rowIndex}}" [innerHTML]="dataItem.tagNumber_View">
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="acdAction" title="ACD Action" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}">
                {{dataItem.acdAction}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="eplLong" title="EPL Long" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}"
                *ngIf="(dataItem.subAssemblyComp == 0 || dataItem.subAssemblyComp == null) || dataItem.acdAction == 'Add'">
                {{dataItem.eplLong}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="itemShort" title="Item Short" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div class="" *ngIf="dataItem.acdAction != 'Delete'">
                <kendo-textbox [(ngModel)]="dataItem.itemShort" [disabled]="!isUserHaveAccess"
                  (valueChange)="onItemValueChange(dataItem, 'itemShort', $event)"
                  [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('itemShort')}"
                  id="{{ dataItem.bomId + '_itemShort' }}" style="width: 80%"></kendo-textbox>
                <span (click)="openActionPopup('itemShort',rowIndex, dataItem)"
                  [class.icon-disabled2]="!isUserHaveAccess"><fa-icon [icon]="iconPacks.FASEARCH" class="primaryBlue"
                    style="width: 20%; margin-left: 5px"
                    [ngClass]="isUserHaveAccess?'':'icon-disabled2'"></fa-icon></span>
              </div>
              <span [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}" *ngIf="dataItem.acdAction == 'Delete'">
                {{dataItem.itemShort}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="itemLong" title="Item Long" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [ngClass]="{'strike-text': dataItem.acdAction === 'Delete'}">
                <!-- *ngIf="(dataItem.subAssemblyComp == 0 || dataItem.subAssemblyComp == null) || dataItem.acdAction != 'Add' "> -->
                {{dataItem.itemLong}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="quantity" title="Quantity" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="dataItem.acdAction != 'Delete'">
                <kendo-numerictextbox [(ngModel)]="dataItem.quantity" format="##" [min]="0"
                  [disabled]="!isUserHaveAccess" (valueChange)="onItemValueChange(dataItem, 'quantity', $event)"
                  [ngClass]="{'backgroundChange': dataItem.acdAction === 'Add' || dataItem.fieldChangedList?.includes('quantity')}"
                  id="{{ dataItem.bomId + '_quantity' }}"></kendo-numerictextbox>
              </div>
              <span [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}" *ngIf="dataItem.acdAction == 'Delete'">
                {{dataItem.quantity}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="description" title="Description" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [ngClass]="{'strike-text': dataItem.acdAction == 'Delete'}">
                {{dataItem.description}}
              </span>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div>
          <span class="eplLength">{{ eplChildViewData.length }} Item</span>
        </div>
      </div>
    </kendo-expansionpanel>
    <div class="bottomButtons">
      <button class="button-back" (click)="backBTNClicked()">
        <a class="backLink">Back</a>
      </button>
      <button class="button-secondary btn2" style="margin-left: 78%" [disabled]="!isUserHaveAccess"
        [ngClass]="!isUserHaveAccess?'btn-disabled':''" (click)="saveAndAddToCr()">
        Save and Add to CR
      </button>
    </div>
  </div>
</div>

<!-- Start - Add Or Delete Item Popup -->
<app-content-popup *ngIf="showAddOrDeletePopup" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closePopup()">
  <ng-container>
    <form [formGroup]="addEPlForm">
      <div class="inline-row">
        <kendo-label>EPL <span class="mandatory">*</span></kendo-label>
        <div>
          <kendo-dropdownlist class="dd-width-300" [data]="eplList" [valuePrimitive]="true" valueField="id"
            textField="text" [(ngModel)]="eplId" [fillMode]="'flat'" formControlName="eplId" (valueChange)="onEplChange($event)"></kendo-dropdownlist>
          <kendo-formerror class="facility" 
            *ngIf="(this.addEPlForm.controls['eplId'].touched || this.addEPlForm.controls['eplId'].dirty) && (this.addEPlForm.controls['eplId'].errors?.['required'] || this.addEPlForm.controls['eplId'].errors?.['min'])">
            Required field
          </kendo-formerror>
        </div>
      </div>
      <div class="inline-row">
        <kendo-label>Sub-Assembly</kendo-label>
            <kendo-dropdownlist 
            class="dd-width-300"
            [data]="subAssemblyList" 
            valueField="itemShort"
            textField="itemValue" 
            [(ngModel)]="selectedParameterId" 
            [valuePrimitive]="true"
            [fillMode]="'flat'"
            formControlName="subAssemblyId"
           >
            </kendo-dropdownlist>

      </div>
      <div class="inline-row">
        <kendo-label>Item(s) <span class="mandatory">*</span></kendo-label>
        <div>
          <kendo-textarea class="dd-width-300" [(ngModel)]="eplItems" placeholder="Enter Item Short Values" formControlName="eplItemIds"></kendo-textarea>
          <kendo-formerror class="facility"
            *ngIf="(this.addEPlForm.controls['eplItemIds'].touched || this.addEPlForm.controls['eplItemIds'].dirty) && this.addEPlForm.controls['eplItemIds'].errors?.['required']">
            Required field
          </kendo-formerror>
        </div>
      </div>

      <div class="inline-row">
        <div></div>
        <div class="btnList">
          <button class="action-BTN" (click)="addDeleteItem(true)">Add</button>
          <button class="action-BTN" (click)="addDeleteItem(false)">Delete</button>
          <button class="action-cancel-BTN" (click)="closePopup()">
            Cancel
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</app-content-popup>
<!-- End - Add Or Delete Item Popup -->

<!-- Start - Add Epl Tag -->
<app-content-popup *ngIf="showTagPopup" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closePopup()">
  <ng-container>
    <div class="margin-10">
      <div class="popup-search-block">
        <kendo-textbox class="searchField-Text" [(ngModel)]="searchString"
          placeholder="Insert tag number (total or partial) to search for"
          (keydown.enter)="popupEquipmentSearch()"></kendo-textbox>
        <div class="searchField-Action">
          <button class="search-action" (click)="popupEquipmentSearch()">
            Search
          </button>
          <button class="reset-action" (click)="resetData()">Reset</button>
        </div>
      </div>
      <div class="margin-10 mt-20">
        <div class="popup-table-block">
          <kendo-grid class="popup-table-container" [data]="dataList" (selectionChange)="equipmenTagSelectionChange()"
            [selectable]="{ enabled: true, checkboxOnly: true }" kendoGridSelectBy [(selectedKeys)]="tagSelectedIds">
            <kendo-grid-checkbox-column [width]="45" [headerClass]="{ 'text-center': true }"
              [class]="{ 'text-center': true }" [resizable]="false" [columnMenu]="true" id="my-grid"
              [columnMenu]="false" [showSelectAll]="true" class="customgrid"></kendo-grid-checkbox-column>
            <kendo-grid-column field="branchPlant" title="Branch Plant" [width]="150"></kendo-grid-column>
            <kendo-grid-column field="tag" title="Equipment Tag" [width]="150"></kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
      <div class="margin-10 mt-20">
        <div class="margin-10 popup-search-block">
          <kendo-textbox class="searchField-Text" [(ngModel)]="addTagText"
            (keydown.enter)="popupEquipmentSearch()"></kendo-textbox>
          <div class="searchField-Action">
            <button class="reset-action" (click)="addEplTag()">
              Add Tag(s)
            </button>
            <button class="reset-action" (click)="resetData()">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-content-popup>
<!-- Start - Add Epl Tag -->

<!-- Start - Import Items Popup -->
<app-content-popup *ngIf="showFileUploadPopup" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closePopup()">
  <ng-container>
    <app-build-import [setFieldValidationInput]="fieldValidationInput"
      (contentValidated)="imported($event)"></app-build-import>
  </ng-container>
</app-content-popup>
<!-- End - Import Items Popup -->

<!-- Start - Select Item Short Popup -->
<app-content-popup *ngIf="popupShow" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)">
  <ng-container>
    <app-select-item-popup [setColumnConfig]="popupGridColumn" [setPlaceholder]="searchPlaceHolder"
      [setGridData]="popupDataList" (sendDataItem)="dataItemSelected($event)"
      (pageChanged)="popupPageChanged($event)"></app-select-item-popup>
  </ng-container>
</app-content-popup>
<!-- End - Select Item Short Popup -->

<ng-template #template>
  <ul>
    <li *ngFor="let tagNumber of tagNumberList">
      <span>{{tagNumber}}</span>
    </li>
  </ul>
</ng-template>
